import {
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  VOID7hggqo3abtya as VOID,
  indexOfwa4w6635jewi as indexOf,
  ArrayList3it5z8td81qkl as ArrayList,
  split2bvyvnrlcifjv as split,
  Unit_instanceat14thlj150z as Unit_instance,
  joinToString1cxrrlmo0chqs as joinToString,
  startsWith26w8qjqapeeq6 as startsWith,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  trim6jpmwojjgb3l as trim,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  lastIndexOfpmd3ei5son2n as lastIndexOf,
  substringBefore3n7kj60w69hju as substringBefore,
  contains2el4s70rdq4ld as contains,
  Enum3alwj03lh1n41 as Enum,
  Long2qws0ah9gnpki as Long,
  toString30pk9tzaqopn as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  copyToArray2j022khrow2yi as copyToArray,
  toLongw1zpgk99d84b as toLong,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  toString1pkumu07cwy4m as toString_0,
  boxApply1qmzdb3dh90hg as boxApply,
  arrayConcat3qsij7vh68m69 as arrayConcat,
  toList383f556t1dixk as toList,
  toString14fd7g605f91p as toString_1,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance,
  DateTime__toString_impl_cnueje2ackcuvowzg0n as DateTime__toString_impl_cnueje,
  DateTime2gld4ho36azq9 as DateTime,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  asyncz02dsa2nb2zt as async,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo2jsx0o5buj2sw as readBytesUpTo,
  copyTo30i4m6zj8kjfa as copyTo,
  openAsync37anb1e84urmo as openAsync,
  openSync2m3qn99fqytu0 as openSync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  DummyAutoCloseable_instance1ke7zmve5v50 as DummyAutoCloseable_instance,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  toString2x583ovdqfjci as toString_2,
  toByteArraybbc3ng3wgt1d as toByteArray,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import { Companion_getInstance1vfndg47rf0 as Companion_getInstance_0 } from './korlibs-io-fs-root-korlibs-io-fs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class FinalVfsFile {
  static v3d(file) {
    var $this = createThis(this);
    $this.u3d_1 = file;
    return $this;
  }
  static w3d(vfs, path) {
    return this.v3d(vfs.cj(path));
  }
  x3d() {
    return this.u3d_1.a3e_1;
  }
  d3e() {
    return this.u3d_1.b3e_1;
  }
  toString() {
    return 'FinalVfsFile(file=' + this.u3d_1.toString() + ')';
  }
  hashCode() {
    return this.u3d_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this.u3d_1.equals(tmp0_other_with_cast.u3d_1))
      return false;
    return true;
  }
}
class VfsNamed {
  constructor(pathInfo) {
    this.g3e_1 = pathInfo;
  }
  f3e() {
    return this.g3e_1;
  }
}
class VfsOpenMode extends Enum {
  constructor(name, ordinal, cmode, write, createIfNotExists, truncate, read, append, createNew) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    read = read === VOID ? true : read;
    append = append === VOID ? false : append;
    createNew = createNew === VOID ? false : createNew;
    super(name, ordinal);
    this.j3e_1 = cmode;
    this.k3e_1 = write;
    this.l3e_1 = createIfNotExists;
    this.m3e_1 = truncate;
    this.n3e_1 = read;
    this.o3e_1 = append;
    this.p3e_1 = createNew;
  }
}
class VfsStat {
  constructor(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().i35_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    exception = exception === VOID ? null : exception;
    this.q3e_1 = file;
    this.r3e_1 = exists;
    this.s3e_1 = isDirectory;
    this.t3e_1 = size;
    this.u3e_1 = device;
    this.v3e_1 = inode;
    this.w3e_1 = mode;
    this.x3e_1 = owner;
    this.y3e_1 = group;
    this.z3e_1 = createTime;
    this.a3f_1 = modifiedTime;
    this.b3f_1 = lastAccessTime;
    this.c3f_1 = extraInfo;
    this.d3f_1 = kind;
    this.e3f_1 = id;
    this.f3f_1 = exception;
  }
  f3e() {
    return this.q3e_1.f3e();
  }
  g3f(showFile) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList.w(16);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.VfsStat.toString.<anonymous>' call
    if (showFile)
      this_0.h('file=' + this.q3e_1.toString());
    else
      this_0.h('file=' + this.q3e_1.h3f());
    this_0.h('exists=' + this.r3e_1);
    this_0.h('isDirectory=' + this.s3e_1);
    this_0.h('size=' + this.t3e_1.toString());
    this_0.h('device=' + this.u3e_1.toString());
    this_0.h('inode=' + this.v3e_1.toString());
    this_0.h('mode=' + this.w3e_1);
    this_0.h('owner=' + this.x3e_1);
    this_0.h('group=' + this.y3e_1);
    this_0.h('createTime=' + DateTime__toString_impl_cnueje(this.z3e_1));
    this_0.h('modifiedTime=' + DateTime__toString_impl_cnueje(this.a3f_1));
    this_0.h('lastAccessTime=' + DateTime__toString_impl_cnueje(this.b3f_1));
    this_0.h('extraInfo=' + toString(this.c3f_1));
    if (!(this.d3f_1 == null)) {
      this_0.h('kind=' + toString(this.d3f_1));
    }
    this_0.h('id=' + this.e3f_1);
    return 'VfsStat(' + joinToString(this_0, ', ') + ')';
  }
  toString() {
    return this.g3f(true);
  }
  i3f(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception);
  }
  j3f(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception, $super) {
    file = file === VOID ? this.q3e_1 : file;
    exists = exists === VOID ? this.r3e_1 : exists;
    isDirectory = isDirectory === VOID ? this.s3e_1 : isDirectory;
    size = size === VOID ? this.t3e_1 : size;
    device = device === VOID ? this.u3e_1 : device;
    inode = inode === VOID ? this.v3e_1 : inode;
    mode = mode === VOID ? this.w3e_1 : mode;
    owner = owner === VOID ? this.x3e_1 : owner;
    group = group === VOID ? this.y3e_1 : group;
    createTime = createTime === VOID ? this.z3e_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.a3f_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.b3f_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.c3f_1 : extraInfo;
    kind = kind === VOID ? this.d3f_1 : kind;
    id = id === VOID ? this.e3f_1 : id;
    exception = exception === VOID ? this.f3f_1 : exception;
    return $super === VOID ? this.i3f(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) : $super.i3f.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id, exception);
  }
  hashCode() {
    var result = this.q3e_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.r3e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s3e_1) | 0;
    result = imul(result, 31) + this.t3e_1.hashCode() | 0;
    result = imul(result, 31) + this.u3e_1.hashCode() | 0;
    result = imul(result, 31) + this.v3e_1.hashCode() | 0;
    result = imul(result, 31) + this.w3e_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.x3e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y3e_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.z3e_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.a3f_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.b3f_1) | 0;
    result = imul(result, 31) + (this.c3f_1 == null ? 0 : hashCode(this.c3f_1)) | 0;
    result = imul(result, 31) + (this.d3f_1 == null ? 0 : hashCode(this.d3f_1)) | 0;
    result = imul(result, 31) + (this.e3f_1 == null ? 0 : getStringHashCode(this.e3f_1)) | 0;
    result = imul(result, 31) + (this.f3f_1 == null ? 0 : hashCode(this.f3f_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.q3e_1.equals(tmp0_other_with_cast.q3e_1))
      return false;
    if (!(this.r3e_1 === tmp0_other_with_cast.r3e_1))
      return false;
    if (!(this.s3e_1 === tmp0_other_with_cast.s3e_1))
      return false;
    if (!this.t3e_1.equals(tmp0_other_with_cast.t3e_1))
      return false;
    if (!this.u3e_1.equals(tmp0_other_with_cast.u3e_1))
      return false;
    if (!this.v3e_1.equals(tmp0_other_with_cast.v3e_1))
      return false;
    if (!(this.w3e_1 === tmp0_other_with_cast.w3e_1))
      return false;
    if (!(this.x3e_1 === tmp0_other_with_cast.x3e_1))
      return false;
    if (!(this.y3e_1 === tmp0_other_with_cast.y3e_1))
      return false;
    if (!equals(this.z3e_1, tmp0_other_with_cast.z3e_1))
      return false;
    if (!equals(this.a3f_1, tmp0_other_with_cast.a3f_1))
      return false;
    if (!equals(this.b3f_1, tmp0_other_with_cast.b3f_1))
      return false;
    if (!equals(this.c3f_1, tmp0_other_with_cast.c3f_1))
      return false;
    if (!equals(this.d3f_1, tmp0_other_with_cast.d3f_1))
      return false;
    if (!(this.e3f_1 == tmp0_other_with_cast.e3f_1))
      return false;
    if (!equals(this.f3f_1, tmp0_other_with_cast.f3f_1))
      return false;
    return true;
  }
}
class Companion {}
class VfsCachedStatContext {
  constructor(stat) {
    this.k3f_1 = stat;
  }
  v1() {
    return Companion_instance;
  }
}
class Companion_0 {
  l3f() {
    return Standard_STRING_getInstance();
  }
}
class Standard extends Enum {}
class Vfs$Proxy$watch$slambda$slambda {
  constructor(this$0, $e, $handler) {
    this.p3f_1 = this$0;
    this.q3f_1 = $e;
    this.r3f_1 = $handler;
  }
  f2y($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Vfs$Proxy$initOnce$slambda {
  constructor(this$0) {
    this.m3f_1 = this$0;
  }
  f2y($this$async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Vfs$Proxy$watch$slambda {
  constructor(this$0, $handler) {
    this.f3g_1 = this$0;
    this.g3g_1 = $handler;
  }
  h3g(e, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.hd();
    var tmp = CoroutineScope_0(tmp$ret$0);
    launch(tmp, VOID, VOID, Vfs$Proxy$watch$slambda$slambda_0(this.f3g_1, e, this.g3g_1));
  }
  le(p1, $completion) {
    return this.h3g(p1 instanceof FileEvent ? p1 : THROW_CCE(), $completion);
  }
}
class Kind extends Enum {}
class Vfs {
  constructor($box) {
    boxApply(this, $box);
  }
  h3f() {
    return '';
  }
  n3g(path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.h3f()), get_pathInfo(path)));
  }
  o3g() {
    return new VfsFile(this, '');
  }
  cj(path) {
    return this.o3g().cj(path);
  }
  d3g(path) {
    return this.o3g().cj(path);
  }
  r2z($completion) {
    return Unit_instance;
  }
  p3g(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    // Inline function 'kotlin.also' call
    var this_0 = new VfsStat(this.d3g(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.Vfs.createExistsStat.<anonymous>' call
    if (cache)
      this_0.q3e_1.c3e_1 = this_0;
    return this_0;
  }
  q3g(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().i35_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance().i35_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.p3g(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.p3g.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  }
  r3g(path, extraInfo, cache, exception) {
    return new VfsStat(this.d3g(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance().i35_1, Companion_getInstance().i35_1, Companion_getInstance().i35_1, extraInfo, VOID, VOID, exception);
  }
  s3g(path, extraInfo, cache, exception, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    exception = exception === VOID ? null : exception;
    return $super === VOID ? this.r3g(path, extraInfo, cache, exception) : $super.r3g.call(this, path, extraInfo, cache, exception);
  }
  i3g(path, mode, $completion) {
    unsupported(this);
  }
  j3g(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t_0.bind(VOID, this, path, range), $completion);
  }
  k3g(path, content, attributes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_put__cb93wb_0.bind(VOID, this, path, content, attributes), $completion);
  }
  t3g(path, content, attributes, $completion) {
    return this.k3g(path, openAsync(content), attributes, $completion);
  }
  l3g(path, $completion) {
    return this.s3g(path);
  }
  m3g(path, handler, $completion) {
    return DummyAutoCloseable_instance;
  }
  e3e(path, $completion) {
    return FinalVfsFile.w3d(this, path);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
}
class Proxy extends Vfs {
  constructor() {
    super();
    this.n3f_1 = null;
  }
  v3f(_this__u8e3s4, $completion) {
    return this.d3g(_this__u8e3s4.b3e_1);
  }
  e3e(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getUnderlyingUnscapedFile__y1cdv2.bind(VOID, this, path), $completion);
  }
  o3f($completion) {
  }
  x3f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_initOnce__uuyf07.bind(VOID, this), $completion);
  }
  i3g(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea.bind(VOID, this, path, mode), $completion);
  }
  j3g(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t.bind(VOID, this, path, range), $completion);
  }
  k3g(path, content, attributes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_put__cb93wb.bind(VOID, this, path, content, attributes), $completion);
  }
  l3g(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc.bind(VOID, this, path), $completion);
  }
  m3g(path, handler, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_watch__ws0fd1.bind(VOID, this, path, handler), $completion);
  }
}
class FileEvent {
  constructor(kind, file, other) {
    other = other === VOID ? null : other;
    this.s3f_1 = kind;
    this.t3f_1 = file;
    this.u3f_1 = other;
  }
  toString() {
    return !(this.u3f_1 == null) ? this.s3f_1.toString() + '(' + this.t3f_1.toString() + ', ' + toString(this.u3f_1) + ')' : this.s3f_1.toString() + '(' + this.t3f_1.toString() + ')';
  }
  u3g(kind, file, other) {
    return new FileEvent(kind, file, other);
  }
  w3f(kind, file, other, $super) {
    kind = kind === VOID ? this.s3f_1 : kind;
    file = file === VOID ? this.t3f_1 : file;
    other = other === VOID ? this.u3f_1 : other;
    return $super === VOID ? this.u3g(kind, file, other) : $super.u3g.call(this, kind, file, other);
  }
  hashCode() {
    var result = this.s3f_1.hashCode();
    result = imul(result, 31) + this.t3f_1.hashCode() | 0;
    result = imul(result, 31) + (this.u3f_1 == null ? 0 : this.u3f_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FileEvent ? other : THROW_CCE();
    if (!this.s3f_1.equals(tmp0_other_with_cast.s3f_1))
      return false;
    if (!this.t3f_1.equals(tmp0_other_with_cast.t3f_1))
      return false;
    if (!equals(this.u3f_1, tmp0_other_with_cast.u3f_1))
      return false;
    return true;
  }
}
class VfsFile$watch$lambda$slambda {
  constructor($handler, $event) {
    this.v3g_1 = $handler;
    this.w3g_1 = $event;
  }
  f2y($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class VfsFile extends VfsNamed {
  constructor(vfs, path) {
    super(get_pathInfo(path));
    this.z3d_1 = new Mixin();
    this.a3e_1 = vfs;
    this.b3e_1 = path;
    this.c3e_1 = null;
  }
  c28(_set____db54di) {
    this.z3d_1.c28(_set____db54di);
  }
  d28() {
    return this.z3d_1.d28();
  }
  z3g() {
    return new VfsFile(this.a3e_1, get_folder_0(this));
  }
  o3g() {
    return this.a3e_1.o3g();
  }
  h3f() {
    return this.a3e_1.n3g(this.b3e_1);
  }
  cj(path) {
    return new VfsFile(this.a3e_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.b3e_1), get_pathInfo(path))));
  }
  b3g(content, attributes, $completion) {
    return this.a3e_1.k3g(this.b3e_1, content, toList(attributes), $completion);
  }
  y3g(data, attributes, $completion) {
    return this.a3e_1.t3g(this.b3e_1, data, toList(attributes), $completion);
  }
  z3f(mode, $completion) {
    return this.a3e_1.i3g(this.b3e_1, mode, $completion);
  }
  a3h(mode, $completion, $super) {
    mode = mode === VOID ? VfsOpenMode_READ_getInstance() : mode;
    return $super === VOID ? this.z3f(mode, $completion) : $super.z3f.call(this, mode, $completion);
  }
  a3g(range, $completion) {
    return this.a3e_1.j3g(this.b3e_1, range, $completion);
  }
  b3h($completion) {
    return this.a3e_1.j3g(this.b3e_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
  }
  x3g($completion) {
    return this.b3h($completion);
  }
  c3h($completion) {
    return this.b3h($completion);
  }
  d3h(charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun.bind(VOID, this, charset), $completion);
  }
  e3h(charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.d3h(charset, $completion) : $super.d3h.call(this, charset, $completion);
  }
  f3h(data, attributes, charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_writeString__8z2lpg.bind(VOID, this, data, attributes, charset), $completion);
  }
  g3h(data, attributes, charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.f3h(data, attributes, charset, $completion) : $super.f3h.call(this, data, attributes, charset, $completion);
  }
  c3g($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_0.bind(VOID, this), $completion);
  }
  h3h($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_exists__ioqez8.bind(VOID, this), $completion);
  }
  e3g(handler, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var cc = $completion.hd();
    return this.a3e_1.m3g(this.b3e_1, VfsFile$watch$lambda(cc, handler), $completion);
  }
  i3h() {
    return Companion_instance_1.j3h(this);
  }
  toString() {
    return this.a3e_1.toString() + '[' + this.b3e_1 + ']';
  }
  hashCode() {
    var result = hashCode(this.a3e_1);
    result = imul(result, 31) + getStringHashCode(this.b3e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.a3e_1, tmp0_other_with_cast.a3e_1))
      return false;
    if (!(this.b3e_1 === tmp0_other_with_cast.b3e_1))
      return false;
    return true;
  }
}
class Companion_1 {
  j3h(jailRoot) {
    return (new JailVfs(jailRoot, Unit_instance)).o3g();
  }
}
class JailVfs extends Proxy {
  constructor(jailRoot, dummy) {
    super();
    this.l3h_1 = jailRoot;
    this.m3h_1 = normalize(this.l3h_1.f3e());
  }
  y3f(path, $completion) {
    return this.l3h_1.cj(trim(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  v3f(_this__u8e3s4, $completion) {
    var outPath = normalize(get_pathInfo(_this__u8e3s4.b3e_1));
    if (!startsWith(outPath, this.m3h_1))
      throw UnsupportedOperationException.sa('Jail not base root : ' + _this__u8e3s4.b3e_1 + ' | ' + this.m3h_1);
    // Inline function 'kotlin.text.substring' call
    var startIndex = this.m3h_1.length;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = outPath.substring(startIndex);
    return this.d3g(tmp$ret$1);
  }
  h3f() {
    return this.l3h_1.h3f();
  }
  toString() {
    return 'JailVfs(' + this.l3h_1.toString() + ')';
  }
}
class Companion_2 {}
class LocalVfs extends Vfs {
  constructor(fs) {
    fs = fs === VOID ? Companion_getInstance_0() : fs;
    super();
    this.n3h_1 = fs;
  }
  toString() {
    return 'LocalVfs';
  }
}
class UrlVfs extends Vfs {
  constructor(url, dummy, failFromStatus) {
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super();
    this.o3h_1 = url;
    this.p3h_1 = failFromStatus;
    this.q3h_1 = this.o3h_1;
  }
  h3f() {
    return this.q3h_1;
  }
  r3h(path) {
    var result = trim(this.o3h_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + toString_1(_Char___init__impl__6a9atx(47)) + trim(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  }
}
//endregion
function getUnderlyingUnscapedFile(_this__u8e3s4, $completion) {
  return _this__u8e3s4.a3e_1.e3e(_this__u8e3s4.b3e_1, $completion);
}
function get_fullPathNormalized(_this__u8e3s4) {
  return replace(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
}
function _PathInfo___init__impl__vpw96a(fullPath) {
  return fullPath;
}
function _PathInfo___get_fullPath__impl__21fx6x($this) {
  return $this;
}
function get_parent(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(get_folder(_this__u8e3s4));
}
function normalize(_this__u8e3s4, removeEndSlash) {
  removeEndSlash = removeEndSlash === VOID ? true : removeEndSlash;
  var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var schemeIndex = indexOf(path, ':');
  var tmp;
  if (schemeIndex >= 0) {
    var tmp_0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = path.substring(schemeIndex);
    if (startsWith(tmp$ret$1, '://')) {
      tmp_0 = 3;
    } else {
      tmp_0 = 1;
    }
    var take = tmp_0;
    // Inline function 'kotlin.text.substring' call
    var endIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = path.substring(0, endIndex);
    // Inline function 'kotlin.text.substring' call
    var startIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = path.substring(startIndex);
    tmp = tmp_1 + normalize(get_pathInfo(tmp$ret$5), removeEndSlash);
  } else {
    var path2 = replace(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
    var out = ArrayList.z();
    var path2PathLength;
    // Inline function 'korlibs.io.file.fastForEachWithIndex' call
    // Inline function 'kotlin.also' call
    var this_0 = split(path2, ['/']);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.normalize.<anonymous>' call
    path2PathLength = this_0.g1();
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.io.file.normalize.<anonymous>' call
      var index = n;
      var part = this_0.h1(n);
      switch (part) {
        case '':
          if (out.j1() || !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.h('');
          }

          break;
        case '.':
          if (index === (path2PathLength - 1 | 0) && !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.h('');
          }

          break;
        case '..':
          var tmp_2;
          // Inline function 'kotlin.collections.isNotEmpty' call

          if (!out.j1()) {
            tmp_2 = !(index === 1);
          } else {
            tmp_2 = false;
          }

          if (tmp_2) {
            out.j3(out.g1() - 1 | 0);
          }

          break;
        default:
          // Inline function 'kotlin.collections.plusAssign' call

          out.h(part);
          break;
      }
      n = n + 1 | 0;
    }
    tmp = joinToString(out, '/');
  }
  return tmp;
}
function get_pathInfo(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
}
function get_baseName(_this__u8e3s4) {
  return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
}
function get_baseName_0(_this__u8e3s4) {
  return get_baseName(_this__u8e3s4.f3e());
}
function get_folder(_this__u8e3s4) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  var endIndex = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.js.asDynamic' call
  return this_0.substring(0, endIndex);
}
function get_folder_0(_this__u8e3s4) {
  return get_folder(_this__u8e3s4.f3e());
}
function combine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
}
function get_fullName(_this__u8e3s4) {
  return _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4.f3e());
}
function lightCombine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(base) > 0) {
    tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
  } else {
    tmp = access_0;
  }
  var res = tmp;
  return get_pathInfo(res);
}
function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
  startIndex = startIndex === VOID ? get_lastIndex(_this__u8e3s4) : startIndex;
  // Inline function 'kotlin.takeIf' call
  var this_0 = lastIndexOf(_this__u8e3s4, char, startIndex);
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.io.file.lastIndexOfOrNull.<anonymous>' call
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function isAbsolute(_this__u8e3s4) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(base) === 0)
    return false;
  var b = substringBefore(replace(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(b) === 0)
    return true;
  if (contains(b, _Char___init__impl__6a9atx(58)))
    return true;
  return false;
}
var VfsOpenMode_READ_instance;
var VfsOpenMode_WRITE_instance;
var VfsOpenMode_APPEND_instance;
var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
var VfsOpenMode_CREATE_instance;
var VfsOpenMode_CREATE_NEW_instance;
var VfsOpenMode_entriesInitialized;
function VfsOpenMode_initEntries() {
  if (VfsOpenMode_entriesInitialized)
    return Unit_instance;
  VfsOpenMode_entriesInitialized = true;
  VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
  VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
  VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true, VOID, VOID, true);
  VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
  VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
  VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
var Standard_BINARY_instance;
var Standard_STRING_instance;
var Standard_LONG_instance;
var Standard_INT_instance;
var Standard_entriesInitialized;
function Standard_initEntries() {
  if (Standard_entriesInitialized)
    return Unit_instance;
  Standard_entriesInitialized = true;
  Standard_BINARY_instance = new Standard('BINARY', 0);
  Standard_STRING_instance = new Standard('STRING', 1);
  Standard_LONG_instance = new Standard('LONG', 2);
  Standard_INT_instance = new Standard('INT', 3);
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
function Standard_STRING_getInstance() {
  Standard_initEntries();
  return Standard_STRING_instance;
}
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  try {
    var tmp = $this.m3f_1.o3f($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = $this.p3f_1.v3f($this.q3f_1.t3f_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var f1 = tmp;
  var tmp6_safe_receiver = $this.q3f_1.u3f_1;
  var tmp_0;
  if (tmp6_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = $this.p3f_1.v3f(tmp6_safe_receiver, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var f2 = tmp_0;
  $this.r3f_1($this.q3f_1.w3f(VOID, f1, f2));
  return Unit_instance;
}
function Vfs$Proxy$watch$slambda$slambda_0(this$0, $e, $handler) {
  var i = new Vfs$Proxy$watch$slambda$slambda(this$0, $e, $handler);
  var l = function ($this$launch, $completion) {
    return i.f2y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_getUnderlyingUnscapedFile__y1cdv2($this, path, $completion) {
  var tmp = $this.x3f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.y3f(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = getUnderlyingUnscapedFile(tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_initOnce__uuyf07($this, $completion) {
  if ($this.n3f_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.hd();
    var tmp_0 = CoroutineScope_0(tmp$ret$0.eo(SupervisorJob()).eo(CoroutineName.v2l('Initializing.' + $this.toString())));
    tmp.n3f_1 = async(tmp_0, VOID, VOID, Vfs$Proxy$initOnce$slambda_0($this));
  }
  var tmp_1 = ensureNotNull($this.n3f_1).r2h($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return $this;
}
function *_generator_open__qjxcea($this, path, mode, $completion) {
  var tmp = $this.x3f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.y3f(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.z3f(mode, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_readRange__lxd64t($this, path, range, $completion) {
  var tmp = $this.x3f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.y3f(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.a3g(range, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_put__cb93wb($this, path, content, attributes, $completion) {
  var tmp = $this.x3f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.y3f(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(attributes);
  var tmp_1 = tmp_0.b3g(content, tmp$ret$0.slice(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_stat__qhnowc($this, path, $completion) {
  var tmp = $this.x3f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.y3f(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.c3g($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1.j3f($this.d3g(path));
}
function *_generator_watch__ws0fd1($this, path, handler, $completion) {
  var tmp = $this.x3f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.y3f(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.e3g(Vfs$Proxy$watch$slambda_0($this, handler), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function Vfs$Proxy$initOnce$slambda_0(this$0) {
  var i = new Vfs$Proxy$initOnce$slambda(this$0);
  var l = function ($this$async, $completion) {
    return i.f2y($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function Vfs$Proxy$watch$slambda_0(this$0, $handler) {
  var i = new Vfs$Proxy$watch$slambda(this$0, $handler);
  var l = function (e, $completion) {
    return i.h3g(e, $completion);
  };
  l.$arity = 1;
  return l;
}
var Kind_DELETED_instance;
var Kind_MODIFIED_instance;
var Kind_CREATED_instance;
var Kind_RENAMED_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_DELETED_instance = new Kind('DELETED', 0);
  Kind_MODIFIED_instance = new Kind('MODIFIED', 1);
  Kind_CREATED_instance = new Kind('CREATED', 2);
  Kind_RENAMED_instance = new Kind('RENAMED', 3);
}
function Kind_MODIFIED_getInstance() {
  Kind_initEntries();
  return Kind_MODIFIED_instance;
}
function *_generator_readRange__lxd64t_0($this, path, range, $completion) {
  // Inline function 'korlibs.io.async.useIt' call
  var tmp = $this.i3g(path, VfsOpenMode_READ_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.io.async.use' call
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.io.file.Vfs.readRange.<anonymous>' call
    this_0.b33_1 = range.o1();
    // Inline function 'kotlin.math.min' call
    // Inline function 'kotlin.Long.minus' call
    var a = (new Long(2147483647, 0)).c2(toLong(1));
    var b = range.p1().c2(range.o1());
    var tmp$ret$1 = a.b2(b) <= 0 ? a : b;
    var tmp_1 = readBytesUpTo(this_0, tmp$ret$1.l2() + 1 | 0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_3 = this_0.r2z($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function *_generator_put__cb93wb_0($this, path, content, attributes, $completion) {
  // Inline function 'korlibs.io.async.useThis' call
  var tmp = $this.i3g(path, VfsOpenMode_CREATE_OR_TRUNCATE_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.io.async.use' call
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.io.file.Vfs.put.<anonymous>' call
    var tmp_1 = copyTo(content, this_0, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_3 = this_0.r2z($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function unsupported($this) {
  throw UnsupportedOperationException.sa('unsupported for ' + toString_0(getKClassFromExpression($this)) + ' : ' + $this.toString());
}
function VfsOpenMode_READ_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_READ_instance;
}
function VfsOpenMode_CREATE_OR_TRUNCATE_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_CREATE_OR_TRUNCATE_instance;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_VfsFile_kt__9wj0sz();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = $this.v3g_1($this.w3g_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_readString__6uahun($this, charset, $completion) {
  var tmp = $this.x3g($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_2(tmp, charset);
}
function *_generator_writeString__8z2lpg($this, data, attributes, charset, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp = $this.y3g(toByteArray(data, charset), arrayConcat([attributes, [Companion_instance_0.l3f()]]), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_stat__qhnowc_0($this, $completion) {
  var tmp0_elvis_lhs = $this.c3e_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0 = $this.a3e_1.l3g($this.b3e_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function *_generator_exists__ioqez8($this, $completion) {
  // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
  var tmp;
  try {
    // Inline function 'korlibs.io.file.VfsFile.exists.<anonymous>' call
    var tmp_0 = $this.a3e_1.l3g($this.b3e_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0.r3e_1;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      if (false) {
        printStackTrace(e);
      }
      tmp_1 = null;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function VfsFile$watch$lambda$slambda_0($handler, $event) {
  var i = new VfsFile$watch$lambda$slambda($handler, $event);
  var l = function ($this$launch, $completion) {
    return i.f2y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function VfsFile$watch$lambda($cc, $handler) {
  return function (event) {
    var tmp = CoroutineScope_0($cc);
    launch(tmp, $cc, VOID, VfsFile$watch$lambda$slambda_0($handler, event));
    return Unit_instance;
  };
}
function *_generator_readAsSyncStream__xvjwgr(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.x3g($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return openSync(tmp);
}
function readAsSyncStream(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAsSyncStream__xvjwgr.bind(VOID, _this__u8e3s4), $completion);
}
var properties_initialized_VfsFile_kt_lqx1ld;
function _init_properties_VfsFile_kt__9wj0sz() {
  if (!properties_initialized_VfsFile_kt_lqx1ld) {
    properties_initialized_VfsFile_kt_lqx1ld = true;
    LONG_ZERO_TO_MAX_RANGE = (new Long(0, 0)).e2(new Long(-1, 2147483647));
  }
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
//region block: post-declaration
initMetadataForClass(FinalVfsFile, 'FinalVfsFile');
initMetadataForClass(VfsNamed, 'VfsNamed');
initMetadataForClass(VfsOpenMode, 'VfsOpenMode');
initMetadataForClass(VfsStat, 'VfsStat');
initMetadataForCompanion(Companion);
protoOf(VfsCachedStatContext).ud = get;
protoOf(VfsCachedStatContext).do = fold;
protoOf(VfsCachedStatContext).co = minusKey;
protoOf(VfsCachedStatContext).eo = plus;
initMetadataForClass(VfsCachedStatContext, 'VfsCachedStatContext', VOID, VOID, [Element]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Standard, 'Standard');
initMetadataForLambda(Vfs$Proxy$watch$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(Vfs$Proxy$initOnce$slambda, VOID, VOID, [1]);
initMetadataForLambda(Vfs$Proxy$watch$slambda, VOID, VOID, [1]);
initMetadataForClass(Kind, 'Kind');
initMetadataForClass(Vfs, 'Vfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
initMetadataForClass(Proxy, 'Proxy', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForClass(FileEvent, 'FileEvent');
initMetadataForLambda(VfsFile$watch$lambda$slambda, VOID, VOID, [1]);
initMetadataForClass(VfsFile, 'VfsFile', VOID, VOID, VOID, [0, 2, 3, 1, 4, 5]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(JailVfs, 'JailVfs', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(LocalVfs, 'LocalVfs', VOID, VOID, VOID, [1, 4, 0, 2, 3]);
initMetadataForClass(UrlVfs, 'UrlVfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
export {
  Kind_MODIFIED_getInstance as Kind_MODIFIED_getInstance160cow5c5cqx7,
  VfsOpenMode_READ_getInstance as VfsOpenMode_READ_getInstance1f4z3vmo4033h,
  getUnderlyingUnscapedFile as getUnderlyingUnscapedFilej1r5tpfxb7a7,
  readAsSyncStream as readAsSyncStream2ficq0l6vek7d,
  _PathInfo___init__impl__vpw96a as _PathInfo___init__impl__vpw96aee5jvc40cw94,
  _PathInfo___get_fullPath__impl__21fx6x as _PathInfo___get_fullPath__impl__21fx6x1rfietgv3lnmb,
  Companion_instance as Companion_instance28oneptpyw0i3,
  LocalVfs as LocalVfs18bzski76hhpp,
  UrlVfs as UrlVfs292f1sja450ff,
  FileEvent as FileEvent3ttxpvowuoy72,
  Proxy as Proxy2ri7nr2ijtx4g,
  VfsCachedStatContext as VfsCachedStatContext2gte5m09f8ox9,
  Vfs as Vfs3mgmizq3oi7gy,
  get_baseName as get_baseName7iz3sifr1imo,
  get_baseName_0 as get_baseName2yf63efofm8te,
  get_fullName as get_fullName2a2vm7nxze3wi,
  normalize as normalize34ppus0f5oo02,
  get_parent as get_parent1emraos91g459,
  get_pathInfo as get_pathInfo26tycr2r540oz,
};
//endregion
